import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment } from "react";
import { Button, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faEye, faUser } from "@fortawesome/free-regular-svg-icons";
import { faPhone, faWarning, faCheck, faClipboardUser } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const UsersListXS = (props) => {
    const { t } = useTranslation();
    const { e, i, checkIfUserNeedsAttention, checkIfUserIsNewStudent, onShow, changeView } = props;
    return (
        <Fragment>
            <tr>
                <td rowSpan={!e.user_instagram ? 5 : 6} className="text-center pe-0 pe-lg-2">
                    {checkIfUserNeedsAttention(e).length > 0 && (
                        <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 150, hide: 100 }}
                            overlay={
                                <Tooltip id={`warningUserBtnTooltip${i}`}>
                                    {checkIfUserNeedsAttention(e).map((el, j) => (
                                        <p key={j}>{el}</p>
                                    ))}
                                </Tooltip>
                            }
                        >
                            <Button variant="link" size="sm" className="btn-attention">
                                <FontAwesomeIcon icon={faWarning} className="text-warning" />
                            </Button>
                        </OverlayTrigger>
                    )}
                    {e.user_avatar_name ? (
                        <Image src={`${process.env.REACT_APP_API_URL}/uploads/usersAvatars/${e.user_avatar_name}`} alt={`${e.user_name} ${e.user_surname} avatar`} className="avatar" />
                    ) : (
                        <div className="no-avatar mx-auto">
                            <FontAwesomeIcon icon={faUser} />
                        </div>
                    )}
                </td>

                <td className="border-0 pb-0">
                    {e.user_name} {e.user_surname}
                </td>

                <td className="text-center" rowSpan={!e.user_instagram ? 5 : 6}>
                    {checkIfUserIsNewStudent(e.user_role_code_list) && (
                        <OverlayTrigger placement="bottom" delay={{ show: 150, hide: 100 }} overlay={<Tooltip id={`acceptNewStudentBtnTooltip${i}`}>{t("users.acceptNewStudent")}</Tooltip>}>
                            <Button variant="outline-secondary" className="btn-table-action me-2" onClick={() => onShow(e.user_id)}>
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                        </OverlayTrigger>
                    )}
                    <OverlayTrigger placement="bottom" delay={{ show: 150, hide: 100 }} overlay={<Tooltip id={`userDetailsBtnTooltip${i}`}>{t("users.userDetails")}</Tooltip>}>
                        <Button
                            variant="outline-secondary"
                            className="btn-table-action"
                            onClick={() => changeView({ nav: "users", sub: "userDetails", params: { userID: e.user_id, moduleName: "ADMIN_APP" } })}
                        >
                            <FontAwesomeIcon icon={faEye} />
                        </Button>
                    </OverlayTrigger>
                </td>
            </tr>
            {e.user_instagram && (
                <tr>
                    <td className="border-0 text-break pb-0">
                        <FontAwesomeIcon icon={faInstagram} className="me-1" />
                        {e.user_instagram.replace("https://www.instagram.com/", "").replace("/", "")}
                    </td>
                </tr>
            )}
            <tr>
                <td className="border-0 pb-0">
                    <FontAwesomeIcon icon={faPhone} className="me-2" />
                    {e.user_phone}
                </td>
            </tr>

            <tr>
                <td className="border-0 text-break pb-0">
                    <FontAwesomeIcon icon={faEnvelope} className="me-1" />
                    {e.user_email}
                </td>
            </tr>
            <tr>
                <td className="border-0 pb-0">
                    <FontAwesomeIcon icon={faUser} className="me-2" />
                    <span className="d-lg-none">
                        {e.user_role_name_list.includes("Superadmin")
                            ? e.user_role_name_list.replace("upera", ". A")
                            : e.user_role_name_list.includes("Kursant/-ka wymagająca potwierdzenia")
                            ? "Kursant wym. potw."
                            : e.user_role_name_list}
                    </span>
                    <span className="d-none d-lg-inline">{e.user_role_name_list}</span>
                </td>
            </tr>
            <tr>
                <td className="">
                    <FontAwesomeIcon icon={faClipboardUser} className="me-2" />
                    {t(`users.userStatusesList.${e.user_stat_code}`)}
                </td>
            </tr>
        </Fragment>
    );
};

export default UsersListXS;
